// src/app/services/tour-token.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TourTokenService {
  private readonly apiUrl = `${environment.baseUrl}tour-token`;

  constructor(private http: HttpClient) {}

  // Validate the token and return tours
  validateToken(token: string, params: any) {
    return this.http.get<any>(`${this.apiUrl}/validate/${token}`, {
      params
    });
  }

  validateAutoCancelToken(token: string) {
    return this.http.get<any>(`${this.apiUrl}/validate-auto-cancel/${token}`);
  }
}
